
import { Component, Vue } from 'vue-property-decorator'
import { StationDynamicClient, StationClient } from '@/api'
import BaseList from '@/views/BaseList'
import _, { cloneDeep, find, omit } from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'
@Component({
  name: 'StationList',
  components: {},
  filters: {
    formatStation(station: any) {
      return station ? station.name : '气站已被删除'
    },
    formatPayType(payType: any) {
      const typeList = ['余额', '微信', '刷卡', '撤单']
      return typeList[payType]
    }
  }
})
export default class extends BaseList {
  private stationClient = new StationClient()
  private stationList = []
  private isDownloadAll = false
  public constructor() {
    super()
    this.client = new StationDynamicClient()
    this.listQuery = {
      filter: {
        where: {
          description: { like: '' },
          createdAt: { begin: undefined, end: undefined },
          stationId: undefined
        },
        fields: {
          id: true,
          stationId: true,
          payType: true,
          gasType: true,
          floating_ratio: true,
          volume: true,
          gasPrice: true,
          out: true,
          in: true,
          plate_number: true,
          description: true,
          createdAt: true
        },
        include: [{ relation: 'station' }],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
    await this.getStationList()
  }

  private async getStationList() {
    this.stationList = await this.stationClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true
        },
        order: ['createdAt']
      }
    })
  }

  protected generateQuery(): any {
    const t = _.cloneDeep(this.listQuery)
    const and = []
    if (
      !_.isNil(t.filter.where.description) &&
      !_.isEmpty(t.filter.where.description)
    ) {
      and.push({
        description: { like: `%${t.filter.where.description.like}%` }
      })
    }

    const createdAt = t.filter.where.createdAt
    if (createdAt.begin) {
      and.push({ createdAt: { gte: moment(createdAt.begin).utcOffset(480) } })
    }

    if (createdAt.end) {
      and.push({ createdAt: { lt: moment(createdAt.end).utcOffset(480) } })
    }

    if (_.isNumber(t.filter.where.stationId)) {
      and.push({ stationId: t.filter.where.stationId })
    }
    t.filter.where = { and }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected handleDownload() {
    this.listLoading = true
    const header = [
      '订单编号',
      '气站名称',
      '支付类型',
      '加气类型',
      '加气量',
      '浮动比例',
      '气价',
      '收入',
      '支出',
      '车辆',
      '备注',
      '时间'
    ]
    const filterVal = [
      'id',
      'station.name',
      'payType',
      'gasType',
      'volume',
      'floating_ratio',
      'gasPrice',
      'in',
      'out',
      'plate_number',
      'description',
      'createdAt'
    ]
    const data = _.union([header], this.formatJson(filterVal, this.list))
    this.exportXlsx(data)
    this.listLoading = false
  }

  protected formatJson(filterVal: any, jsonData: any) {
    const data = jsonData.map((v: any) =>
      filterVal.map((j: any) => {
        if (j === 'createdAt') {
          return this.parseTime(v[j])
        } else if (j === 'station.name') {
          if (v['station']) {
            return v['station']['name']
          } else {
            return '气站已删除'
          }
        } else if (j === 'payType') {
          const typeList = ['余额', '微信', '刷卡', '撤单']
          return typeList[v[j]]
        } else {
          return v[j]
        }
      })
    )
    return data
  }

  async onDownloadExcelTap() {
    if (this.isDownloadAll) {
      return
    }
    this.isDownloadAll = true
    let filter: any = this.generateQuery()
    filter = omit(filter, ['filter.limit', 'filter.page', 'filter.skip'])
    const dataStream = await (this
      .client as StationDynamicClient).downloadExcel(filter)
    let a = document.createElement('a')
    // ArrayBuffer 转为 Blob
    let blob = new Blob([dataStream], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    let objectUrl = URL.createObjectURL(blob)
    a.setAttribute('href', objectUrl)
    // 修改下载文件名称
    let filename = ''
    const stationInfo: any = _.find(this.stationList, {
      id: this.listQuery.filter.where.stationId
    })
    if (stationInfo) {
      filename += `${stationInfo.name}-`
    }
    moment()
    let now = moment(new Date()).format('YYYYMMDD_HHmmss')
    filename += `${now}.xlsx`
    a.setAttribute('download', filename)
    a.click()
    this.isDownloadAll = false
  }
}
